import applications from '../api/applications'

export default {
    state: {
        applications: [],
        filters:[],
    },
    namespaced: true,
    mutations: {
        async saveApplications(state, data) {
            data.applications.forEach(app => {
               app.promotionMethods = JSON.parse(app.promotionMethods);
               app.websites = JSON.parse(app.websites);
               app.audienceMatch = JSON.parse(app.audienceMatch);
            });
            state.applications = data.applications;
            state.filters = data.filters;
        },
        async massUpdate(state, date) {

        }
    },
    actions: {
        async getApplications({dispatch, commit}, data) {
            commit('saveApplications', await applications.getApplications(data));
        },
        async massUpdate({dispatch, commit}, data) {
            commit('massUpdate', await applications.massApplicationUpdate(data));
        }
    },
    getters: {
        applications: state => state.applications,
        filters: state => state.filters,
    },
}
